import React, { createContext, useContext, useState, useEffect, useCallback, useMemo } from "react";
import axios from "axios";
import { dict } from "@/i18n/translations";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

// El backend usa este dato para armar los enlaces de correos y responsivas con el dominio real
axios.defaults.headers.common["X-App-Origin"] = window.location.origin;
api.defaults.headers.common["X-App-Origin"] = window.location.origin;

const AppCtx = createContext(null);
export const useApp = () => useContext(AppCtx);

export const AppProvider = ({ children }) => {
  const [lang, setLang] = useState(localStorage.getItem("zenda_lang") || "es");
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [pkg, setPkg] = useState(() => {
    try { return JSON.parse(localStorage.getItem("zenda_pkg") || "[]"); } catch { return []; }
  });

  useEffect(() => { localStorage.setItem("zenda_pkg", JSON.stringify(pkg)); }, [pkg]);

  const addToPkg = (item) => {
    let added = false;
    setPkg((prev) => {
      if (prev.some((x) => x.departure_id === item.departure_id)) return prev;
      added = true;
      return [...prev, item];
    });
    return added;
  };
  const removeFromPkg = (departure_id) =>
    setPkg((prev) => prev.filter((x) => x.departure_id !== departure_id));
  const clearPkg = () => setPkg([]);
  const setPkgPeople = (departure_id, participants) =>
    setPkg((prev) => prev.map((x) => (x.departure_id === departure_id ? { ...x, participants } : x)));

  const t = dict[lang];

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(null);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const toggleLang = () => {
    const next = lang === "es" ? "en" : "es";
    setLang(next);
    localStorage.setItem("zenda_lang", next);
  };

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/perfil";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const logout = async () => {
    await api.post("/auth/logout");
    setUser(null);
  };

  const value = useMemo(() => ({
    lang, t, toggleLang, user, setUser, loading, login, logout, checkAuth,
    pkg, addToPkg, removeFromPkg, clearPkg, setPkgPeople,
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }), [lang, t, user, loading, pkg]);

  return (
    <AppCtx.Provider value={value}>
      {children}
    </AppCtx.Provider>
  );
};
